import { gateway } from "../../../gateway";

export const getInvitations = async (type?: string, page?: number, pageSize?: number) => {
  const token = sessionStorage.getItem("token");

  const params: Record<string, string | number> = {};
  if (type) params.type = type;
  if (page) params.page = page;
  if (pageSize) params.pageSize = pageSize;

  const res = await gateway.get("/invitations", {
    params,
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
  return res.data;
};

export const getReceivedInvitations = async (page?: number, pageSize?: number) => {
  const params: Record<string, string | number> = {};

  if (page) params.page = page;
  if (pageSize) params.pageSize = pageSize;

  const res = await gateway.get("/invitations/received", {
    params,
  });

  return res.data;
};
